import React from "react";
import ITAuditorDashboard from "../../pages/dashboard/ITAuditorDashboard";
import { Routes, Route } from "react-router-dom";

const AuditorRoutes = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<ITAuditorDashboard />} />
    </Routes>
  );
};

export default AuditorRoutes;
